export { default } from "./configureStore";
